import { EventFeedType } from '@api/api/event-feed';
import {
  ExploreInsightCondition,
  ExploreInsightDirection,
} from '@api/api/explore-filter-schema';
import { InsightFilter } from '@api/api/insights';

export type InsightCardType = InsightFilter & {
  conditions: ExploreInsightCondition[];
  direction: ExploreInsightDirection;
  date: string;
};

export type InsightsPeriod = {
  duration: number;
  unit: string;
};

export const DEFAULT_WHATS_NEW_PERIOD: InsightsPeriod = {
  duration: 1,
  unit: 'day',
};

export type WhatsNewTabType = 'watchlistFocus' | 'marketExplore' | 'news';

export type WhatsNewSubTabType =
  | 'all'
  | 'company_catalyst'
  | 'market_catalyst'
  | 'scenarios'
  | 'earnings'
  | 'summaries'
  | 'news'
  | 'thematic'
  | 'macroeconomic'
  | 'geopolitical';

export const subTabTypeToEventFeedType: Record<
  WhatsNewSubTabType,
  EventFeedType | undefined
> = {
  all: undefined,
  company_catalyst: 'attribution-insight',
  market_catalyst: 'attribution-insight',
  scenarios: 'scenario-insight',
  earnings: 'earnings-insight',
  summaries: 'market-overview',
  news: undefined,
  thematic: 'attribution-insight',
  macroeconomic: 'attribution-insight',
  geopolitical: 'attribution-insight',
};

const whatsNewTabTypes: Record<WhatsNewTabType, true> = {
  watchlistFocus: true,
  marketExplore: true,
  news: true,
};

export const isWhatsNewTabType = (value: string): value is WhatsNewTabType =>
  value in whatsNewTabTypes;

export const isWhatsNewSubTabType = (
  value: string
): value is WhatsNewSubTabType => value in subTabTypeToEventFeedType;

export const isInsightsPeriod = (value: unknown): value is InsightsPeriod =>
  typeof value === 'object' &&
  value !== null &&
  'duration' in value &&
  'unit' in value;
